import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';

function MarketingTarget() {
  useEffect(() => {
    // Disable right-click
    const handleContextMenu = (e) => {
      e.preventDefault();
      return false;
    };

    // Disable certain keyboard shortcuts
    const handleKeyDown = (e) => {
      if (
        e.key === 'F12' ||
        (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'J')) ||
        (e.ctrlKey && e.key === 'U')
      ) {
        e.preventDefault();
        return false;
      }
    };

    // Disable text selection and copy
    const handleCopy = (e) => {
      e.preventDefault();
      return false;
    };

    // Disable drag
    const handleDragStart = (e) => {
      e.preventDefault();
      return false;
    };

    // Add event listeners
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('copy', handleCopy);
    document.addEventListener('dragstart', handleDragStart);

    // Disable text selection via CSS
    document.body.style.userSelect = 'none';
    document.body.style.webkitUserSelect = 'none';
    document.body.style.msUserSelect = 'none';

    // Cleanup
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('copy', handleCopy);
      document.removeEventListener('dragstart', handleDragStart);
      document.body.style.userSelect = '';
      document.body.style.webkitUserSelect = '';
      document.body.style.msUserSelect = '';
    };
  }, []);

  return (
    <div className="bg-black text-white min-h-screen overflow-x-hidden w-full">
      {/* Navbar */}
      <Navbar />

      {/* Protection styles for images */}
      <style jsx>{`
        img {
          pointer-events: none;
          user-select: none;
          -webkit-user-drag: none;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
        }
        html, body {
          overflow-x: hidden;
          max-width: 100%;
        }
      `}</style>

      {/* Background stars effect */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
        {[...Array(80)].map((_, i) => (
          <div
            key={i}
            className="absolute bg-white rounded-full opacity-50"
            style={{
              width: Math.random() * 2 + 1 + 'px',
              height: Math.random() * 2 + 1 + 'px',
              top: Math.random() * 100 + '%',
              left: Math.random() * 100 + '%',
            }}
          />
        ))}
      </div>

      {/* Hero Section - Marketing Based on Targeting */}
      <section className="relative px-4 sm:px-8 lg:px-24 pt-20 pb-12 sm:py-20 overflow-hidden">
        <div className="max-w-7xl mx-auto relative z-10">
          
          <div className="grid lg:grid-cols-2 gap-6 sm:gap-12 items-center">
            
            {/* Left Side - Content */}
            <div className="space-y-6">
              
              {/* Main Heading */}
              <h1 className="text-4xl lg:text-5xl font-bold text-white leading-tight">
                Marketing Based on Targeting
              </h1>

              {/* Description */}
              <p className="text-gray-300 text-base lg:text-lg leading-relaxed">
                Understanding your audience is the foundation of effective marketing. Different targeting strategies unlock different opportunities, channels, and messaging approaches that can make or break your campaign success.
              </p>

            </div>

            {/* Right Side - Image */}
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden border-1 border-cyan-400 shadow-2xl shadow-cyan-500/50">
                <img 
                  src="/Assests/home_page_67.png" 
                  alt="Marketing Meeting" 
                  className="w-full h-[250px] object-cover"
                />
              </div>
              
              {/* Floating glow effects */}
              <div className="absolute top-0 right-0 w-32 h-32 bg-orange-500/30 rounded-full blur-3xl animate-pulse" />
              <div className="absolute bottom-0 left-0 w-32 h-32 bg-cyan-500/30 rounded-full blur-3xl animate-pulse" style={{animationDelay: '1s'}} />
            </div>

          </div>

        </div>
      </section>

      {/* The Landscape of Targeting Strategies Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 pb-3">
        <div className="max-w-7xl mx-auto">
          
          <div className="grid lg:grid-cols-2 gap-6 sm:gap-12 items-center">
            
            {/* Left Side - Content */}
            <div className="space-y-6">
              
              {/* Main Heading */}
              <h2 className="text-3xl lg:text-4xl font-bold text-white leading-tight">
                The Landscape of Targeting Strategies
              </h2>

              {/* First Paragraph */}
              <p className="text-gray-300 text-base lg:text-lg leading-relaxed">
                In today's complex marketing ecosystem, choosing the right targeting approach determines your resource allocation, message crafting, and platform selection. Each strategy addresses different buying behaviors, decision-making processes, and customer journeys.
              </p>

              {/* Second Paragraph */}
              <p className="text-gray-300 text-base lg:text-lg leading-relaxed">
                Whether you're selling enterprise software or consumer products, understanding these fundamental targeting approaches helps you align your marketing investments with your business goals and audience needs.
              </p>

            </div>

            {/* Right Side - Image */}
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden border-1 border-cyan-400 shadow-2xl shadow-cyan-500/50">
                <img 
                  src="/Assests/home_page_68.png" 
                  alt="Marketing Network Connections" 
                  className="w-full h-[380px] object-cover"
                />
              </div>
              
              {/* Floating glow effects */}
              <div className="absolute top-0 right-0 w-32 h-32 bg-orange-500/30 rounded-full blur-3xl animate-pulse" />
              <div className="absolute bottom-0 left-0 w-32 h-32 bg-cyan-500/30 rounded-full blur-3xl animate-pulse" style={{animationDelay: '1s'}} />
            </div>

          </div>

        </div>
      </section>

      {/* Section 1: B2B Marketing - Business-to-Business */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20">
        <div className="max-w-7xl mx-auto">
          
          <div className="grid lg:grid-cols-2 gap-6 sm:gap-12 items-center">
            
            {/* Left Side - Content */}
            <div className="space-y-8">
              
              {/* Main Heading */}
              <h2 className="text-3xl lg:text-4xl font-bold text-white leading-tight">
                B2B Marketing: Business-to-Business
              </h2>

              {/* Cards Grid */}
              <div className="grid gap-6">
                
                {/* Card 1 - Longer Sales Cycles */}
                <div className="bg-black border border-orange-500 rounded-2xl p-6 space-y-4">
                  <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                    <svg className="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-white">Longer Sales Cycles</h3>
                  <p className="text-gray-300 text-base">
                    Complex decision-making processes involving multiple stakeholders and thorough evaluation periods that can span months
                  </p>
                </div>

                {/* Card 2 - Relationship-Driven */}
                <div className="bg-black border border-orange-500 rounded-2xl p-6 space-y-4">
                  <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                    <svg className="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-white">Relationship-Driven</h3>
                  <p className="text-gray-300 text-base">
                    Building trust and demonstrating ROI through case studies, white papers, and ongoing relationship nurturing
                  </p>
                </div>

                {/* Card 3 - Value-Based Selling */}
                <div className="bg-black border border-orange-500 rounded-2xl p-6 space-y-4">
                  <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                    <svg className="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-white">Value-Based Selling</h3>
                  <p className="text-gray-300 text-base">
                    Emphasizing efficiency gains, cost savings, and measurable business outcomes rather than emotional appeals
                  </p>
                </div>

              </div>

              {/* Bottom Description */}
              <p className="text-gray-300 text-base leading-relaxed">
                B2B marketing targets organizations rather than individuals, requiring strategies that address rational purchasing decisions and procurement processes. This approach demands deep industry knowledge, technical expertise, and the ability to communicate complex value propositions to diverse stakeholder groups including executives, managers, and end users.
              </p>

            </div>

            {/* Right Side - Image */}
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden border-1 border-orange-400 shadow-2xl shadow-orange-500/50">
                <img 
                  src="/Assests/home_page_69.png" 
                  alt="B2B Business Meeting" 
                  className="w-full h-[600px] object-cover"
                />
              </div>
              
              {/* Floating glow effects */}
              <div className="absolute top-0 right-0 w-32 h-32 bg-orange-500/30 rounded-full blur-3xl animate-pulse" />
              <div className="absolute bottom-0 left-0 w-32 h-32 bg-yellow-500/30 rounded-full blur-3xl animate-pulse" style={{animationDelay: '1s'}} />
            </div>

          </div>

        </div>
      </section>

      {/* Section 2: B2B Success Factors */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20">
        <div className="max-w-7xl mx-auto">
          
          <div className="grid lg:grid-cols-2 gap-6 sm:gap-12 items-center">
            
            {/* Left Side - Content */}
            <div className="space-y-8">
              
              {/* Main Heading */}
              <h2 className="text-3xl lg:text-4xl font-bold text-white leading-tight mb-8">
                B2B Success Factors
              </h2>

              {/* Factor 1 */}
              <div className="space-y-3">
                <div className="flex items-center gap-4">
                  <span className="text-orange-500 font-bold text-xl">01</span>
                  <div className="flex-1 h-px bg-orange-500"></div>
                </div>
                <h3 className="text-2xl font-bold text-white">Identify Decision Makers</h3>
                <p className="text-gray-300 text-base">
                  Map the organizational structure to understand who influences, approves, and uses your solution
                </p>
              </div>

              {/* Factor 2 */}
              <div className="space-y-3">
                <div className="flex items-center gap-4">
                  <span className="text-orange-500 font-bold text-xl">02</span>
                  <div className="flex-1 h-px bg-orange-500"></div>
                </div>
                <h3 className="text-2xl font-bold text-white">Create Thought Leadership</h3>
                <p className="text-gray-300 text-base">
                  Establish authority through industry insights, research reports, and educational content
                </p>
              </div>

              {/* Factor 3 */}
              <div className="space-y-3">
                <div className="flex items-center gap-4">
                  <span className="text-orange-500 font-bold text-xl">03</span>
                  <div className="flex-1 h-px bg-orange-500"></div>
                </div>
                <h3 className="text-2xl font-bold text-white">Demonstrate Clear ROI</h3>
                <p className="text-gray-300 text-base">
                  Quantify value with case studies, testimonials, and data-driven success stories
                </p>
              </div>

              {/* Factor 4 */}
              <div className="space-y-3">
                <div className="flex items-center gap-4">
                  <span className="text-orange-500 font-bold text-xl">04</span>
                  <div className="flex-1 h-px bg-orange-500"></div>
                </div>
                <h3 className="text-2xl font-bold text-white">Nurture Long-Term Relationships</h3>
                <p className="text-gray-300 text-base">
                  Maintain engagement through account-based marketing and personalized communication
                </p>
              </div>

            </div>

            {/* Right Side - Image */}
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden border-1 border-orange-400 shadow-2xl shadow-orange-500/50">
                <img 
                  src="/Assests/home_page_70.png" 
                  alt="B2B Success Factors" 
                  className="w-full h-[600px] object-cover"
                />
              </div>
              
              {/* Floating glow effects */}
              <div className="absolute top-0 right-0 w-32 h-32 bg-orange-500/30 rounded-full blur-3xl animate-pulse" />
              <div className="absolute bottom-0 left-0 w-32 h-32 bg-yellow-500/30 rounded-full blur-3xl animate-pulse" style={{animationDelay: '1s'}} />
            </div>

          </div>

        </div>
      </section>

      {/* Section 3: B2C Marketing - Business-to-Consumer */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 bg-orange-500/50">
        <div className="max-w-7xl mx-auto">
          
          <div className="grid lg:grid-cols-2 gap-6 sm:gap-12 items-center">
            
            {/* Left Side - Content */}
            <div className="space-y-6">
              
              {/* Main Heading */}
              <h2 className="text-3xl lg:text-4xl font-bold text-white leading-tight">
                B2C Marketing: Business-to-Consumer
              </h2>

              {/* Paragraph 1 */}
              <p className="text-gary-200 text-base lg:text-lg leading-relaxed">
                B2C marketing speaks directly to individual consumers, leveraging emotional connections and immediate gratification. This approach emphasizes brand personality, lifestyle alignment, and creating memorable experiences that resonate on a personal level.
              </p>

              {/* Paragraph 2 */}
              <p className="text-gray-200 text-base lg:text-lg leading-relaxed">
                Unlike B2B, B2C typically involves shorter sales cycles, impulse purchases, and decisions driven by desires, needs, and emotional triggers. Success requires understanding consumer psychology, cultural trends, and the art of storytelling that connects products to aspirations.
              </p>

              {/* Paragraph 3 */}
              <p className="text-gary-200 text-base lg:text-lg leading-relaxed">
                The digital revolution has transformed B2C marketing, enabling real-time engagement, social proof through reviews, and personalized recommendations that guide purchase decisions. Mobile commerce, social media influence, and seamless omnichannel experiences now define modern consumer expectations.
              </p>

            </div>

            {/* Right Side - Image */}
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden  shadow-2xl shadow-black/50">
                <img 
                  src="/Assests/home_page_71.png" 
                  alt="B2C Consumer Shopping" 
                  className="w-full h-[400px] object-cover"
                />
              </div>
              
              {/* Floating glow effects */}
              <div className="absolute top-0 right-0 w-32 h-32 bg-gray-200/40 rounded-full blur-3xl animate-pulse" />
              <div className="absolute bottom-0 left-0 w-32 h-32 bg-white/40 rounded-full blur-3xl animate-pulse" style={{animationDelay: '1s'}} />
            </div>

          </div>

        </div>
      </section>

      {/* Section 1: B2C Marketing Channels */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 overflow-hidden">
          <img 
            src="/Assests/home_page_72.png" 
            alt="B2C Marketing Channels Background" 
            className="w-full h-full object-cover"
          />
        </div>
        
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black/40"></div>

        <div className="max-w-7xl mx-auto relative z-10">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-8 sm:mb-12 text-center">
            B2C Marketing Channels
          </h2>

          {/* 2x2 Grid */}
          <div className="grid md:grid-cols-2 gap-5 sm:gap-8">
            
            {/* Card 1 - Social Media Marketing */}
            <div className="bg-black/40 backdrop-blur-sm border border-orange-500 rounded-2xl p-6 space-y-4">
              <div className="w-12 h-12 bg-transparent border-2 border-orange-500 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-white">Social Media Marketing</h3>
              <p className="text-gray-300 text-base">
                Engage audiences where they spend time, building communities and leveraging influencer partnerships to amplify reach
              </p>
            </div>

            {/* Card 2 - Email Campaigns */}
            <div className="bg-black/40 backdrop-blur-sm border border-orange-500 rounded-2xl p-6 space-y-4">
              <div className="w-12 h-12 bg-transparent border-2 border-orange-500 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-white">Email Campaigns</h3>
              <p className="text-gray-300 text-base">
                Direct communication with personalized offers, abandoned cart reminders, and loyalty program updates
              </p>
            </div>

            {/* Card 3 - Paid Advertising */}
            <div className="bg-black/40 backdrop-blur-sm border border-orange-500 rounded-2xl p-6 space-y-4">
              <div className="w-12 h-12 bg-transparent border-2 border-orange-500 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-white">Paid Advertising</h3>
              <p className="text-gray-300 text-base">
                Strategic placement across search engines, display networks, and social platforms to capture intent
              </p>
            </div>

            {/* Card 4 - Content Marketing */}
            <div className="bg-black/40 backdrop-blur-sm border border-orange-500 rounded-2xl p-6 space-y-4">
              <div className="w-12 h-12 bg-transparent border-2 border-orange-500 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-white">Content Marketing</h3>
              <p className="text-gray-300 text-base">
                Educational and entertaining content that builds brand affinity and guides consumers through the buyer journey
              </p>
            </div>

          </div>

        </div>
      </section>

      {/* Section 2: C2C Marketing - Consumer-to-Consumer */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 overflow-hidden">
          <img 
            src="/Assests/home_page_60.png" 
            alt="C2C Marketing Background" 
            className="w-full h-full object-cover"
          />
        </div>
        
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black/40"></div>

        <div className="max-w-7xl mx-auto relative z-10">
          
          {/* Main Heading */}
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-8">
            C2C Marketing: Consumer-to-Consumer
          </h2>

          {/* Description */}
          <p className="text-gray-300 text-base lg:text-lg leading-relaxed mb-12 max-w-5xl">
            C2C marketing facilitates transactions directly between consumers, creating platforms where individuals buy, sell, or exchange products and services with each other. This model thrives on community trust, user-generated content, and network effects that grow stronger as more participants join.
          </p>

          {/* 3 Numbered Cards */}
          <div className="grid md:grid-cols-3 gap-8">
            
            {/* Card 1 - Marketplace Platforms */}
            <div className="bg-black/40 backdrop-blur-sm border border-orange-500 rounded-2xl p-6 space-y-4">
              <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                <span className="text-black font-bold text-xl">1</span>
              </div>
              <h3 className="text-xl font-bold text-white">Marketplace Platforms</h3>
              <p className="text-gray-300 text-base">
                Companies like eBay, Etsy, and Airbnb enable peer-to-peer transactions while providing infrastructure, trust mechanisms, and payment processing
              </p>
            </div>

            {/* Card 2 - Referral Programs */}
            <div className="bg-black/40 backdrop-blur-sm border border-orange-500 rounded-2xl p-6 space-y-4">
              <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                <span className="text-black font-bold text-xl">2</span>
              </div>
              <h3 className="text-xl font-bold text-white">Referral Programs</h3>
              <p className="text-gray-300 text-base">
                Incentivizing existing customers to recommend products creates authentic advocacy and leverages personal networks for acquisition
              </p>
            </div>

            {/* Card 3 - User Reviews & Ratings */}
            <div className="bg-black/40 backdrop-blur-sm border border-orange-500 rounded-2xl p-6 space-y-4">
              <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                <span className="text-black font-bold text-xl">3</span>
              </div>
              <h3 className="text-xl font-bold text-white">User Reviews & Ratings</h3>
              <p className="text-gray-300 text-base">
                Social proof from fellow consumers carries more weight than brand messaging, influencing purchase decisions and building credibility
              </p>
            </div>

          </div>

        </div>
      </section>

      {/* Section 3: C2C Platform Success Elements */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20">
        <div className="max-w-7xl mx-auto">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-8 sm:mb-12">
            C2C Platform Success Elements
          </h2>

          <div className="grid lg:grid-cols-2 gap-6 sm:gap-12 items-start">
            
            {/* Left Side - Image */}
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden border-1 border-purple-400 shadow-2xl shadow-purple-500/50">
                <img 
                  src="/Assests/home_page_73.png" 
                  alt="C2C Platform Success" 
                  className="w-full h-[450px] object-cover"
                />
              </div>
              
              {/* Floating glow effects */}
              <div className="absolute top-0 right-0 w-32 h-32 bg-purple-500/30 rounded-full blur-3xl animate-pulse" />
              <div className="absolute bottom-0 left-0 w-32 h-32 bg-blue-500/30 rounded-full blur-3xl animate-pulse" style={{animationDelay: '1s'}} />
            </div>

            {/* Right Side - Content */}
            <div className="space-y-8">
              
              {/* Title */}
              <h3 className="text-2xl lg:text-3xl font-bold text-white">
                Building Trust at Scale
              </h3>

              {/* Paragraph 1 */}
              <p className="text-gray-300 text-base lg:text-lg leading-relaxed">
                C2C platforms must establish robust verification systems, dispute resolution mechanisms, and safety features that protect both buyers and sellers. Trust is the currency that enables strangers to transact with confidence.
              </p>

              {/* Paragraph 2 */}
              <p className="text-gray-300 text-base lg:text-lg leading-relaxed">
                Successful platforms implement verified profiles, secure payment escrow, transparent rating systems, and responsive customer support that addresses concerns quickly. These elements transform anonymous transactions into reliable exchanges backed by community accountability.
              </p>

            </div>

          </div>

          {/* Stats Section */}
          <div className="grid md:grid-cols-3 gap-8 mt-16">
            
            {/* Stat 1 */}
            <div className="text-center space-y-4">
              <div className="text-5xl lg:text-6xl font-bold text-white">85%</div>
              <h4 className="text-xl font-bold text-white">Consumer Trust</h4>
              <p className="text-gray-300 text-base">
                Percentage of buyers who check reviews before purchasing from peer sellers
              </p>
            </div>

            {/* Stat 2 */}
            <div className="text-center space-y-4">
              <div className="text-5xl lg:text-6xl font-bold text-white">3.2B</div>
              <h4 className="text-xl font-bold text-white">Global C2C Market</h4>
              <p className="text-gray-300 text-base">
                Estimated market value of consumer-to-consumer e-commerce platforms worldwide
              </p>
            </div>

            {/* Stat 3 */}
            <div className="text-center space-y-4">
              <div className="text-5xl lg:text-6xl font-bold text-white">67%</div>
              <h4 className="text-xl font-bold text-white">Repeat Users</h4>
              <p className="text-gray-300 text-base">
                C2C platform users who engage in multiple transactions annually
              </p>
            </div>

          </div>

        </div>
      </section>

      {/* Section 4: Niche Marketing - Precision Targeting */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 bg-orange-500/50">
        <div className="max-w-6xl mx-auto">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-black mb-6 sm:mb-8">
            Niche Marketing: Precision Targeting
          </h2>

          {/* Description */}
          <p className="text-gray-300 text-base lg:text-lg leading-relaxed mb-12">
            Niche marketing focuses on serving a highly specific segment with unique needs, preferences, or characteristics. Rather than competing in crowded markets, niche strategies dominate smaller audiences by becoming the undisputed expert and preferred choice.
          </p>

          {/* 3 Numbered Points */}
          <div className="space-y-8">
            
            {/* Point 1 */}
            <div className="space-y-3">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-orange-400 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-black font-bold text-xl">1</span>
                </div>
                <h3 className="text-2xl font-bold text-white">Deep Specialization</h3>
              </div>
              <p className="text-gray-200 text-base lg:text-lg leading-relaxed ml-0 sm:ml-16">
                Understanding every nuance of your target segment allows you to create perfectly tailored solutions that generalist competitors can't match. This expertise becomes your competitive moat and justifies premium pricing.
              </p>
            </div>

            {/* Point 2 */}
            <div className="space-y-3">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-orange-400 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-black font-bold text-xl">2</span>
                </div>
                <h3 className="text-2xl font-bold text-white">Community Building</h3>
              </div>
              <p className="text-gray-200 text-base lg:text-lg leading-relaxed ml-0 sm:ml-16">
                Niche audiences often form tight-knit communities. Becoming an active participant and valuable contributor establishes authority and generates word-of-mouth referrals that fuel sustainable growth.
              </p>
            </div>

            {/* Point 3 */}
            <div className="space-y-3">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-orange-400 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-black font-bold text-xl">3</span>
                </div>
                <h3 className="text-2xl font-bold text-white">Lower Competition</h3>
              </div>
              <p className="text-gray-200 text-base lg:text-lg leading-relaxed ml-0 sm:ml-16">
                While the addressable market is smaller, so is the competition. This allows for higher conversion rates, better customer relationships, and more efficient marketing spend with measurable ROI.
              </p>
            </div>

          </div>

        </div>
      </section>

      {/* Section: Identifying Profitable Niches */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 overflow-hidden">
        {/* Animated background gradient */}
        <div className="absolute inset-0 bg-gradient-to-br from-purple-900/20 via-black to-orange-900/20"></div>
        
        <div className="max-w-7xl mx-auto relative z-10">
          
          {/* Main Heading with accent */}
          <div className="text-center mb-16">
            <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
              Identifying Profitable Niches
            </h2>
            <p className="text-gray-400 text-lg max-w-3xl mx-auto">
              Follow these three essential steps to discover and dominate your perfect market segment
            </p>
          </div>

          {/* Timeline Style Cards */}
          <div className="space-y-12">
            
            {/* Step 1 - Research Demand */}
            <div className="grid lg:grid-cols-12 gap-8 items-center">
              {/* Number Circle */}
              <div className="lg:col-span-2 flex justify-center lg:justify-end">
                <div className="relative">
                  <div className="w-20 h-20 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full flex items-center justify-center shadow-2xl shadow-orange-500/50">
                    <span className="text-white font-bold text-3xl">1</span>
                  </div>
                  {/* Connecting line */}
                  <div className="hidden lg:block absolute top-20 left-1/2 transform -translate-x-1/2 w-1 h-24 bg-gradient-to-b from-orange-500 to-transparent"></div>
                </div>
              </div>
              
              {/* Content Card */}
              <div className="lg:col-span-10">
                <div className="bg-gradient-to-r from-orange-500/10 to-transparent border-l-4 border-orange-500 rounded-r-2xl p-8 backdrop-blur-sm hover:from-orange-500/20 transition-all duration-300">
                  <div className="flex items-start gap-6">
                    <div className="flex-shrink-0 w-16 h-16 bg-orange-500/20 rounded-xl flex items-center justify-center">
                      <svg className="w-8 h-8 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                      </svg>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-2xl font-bold text-white mb-3">Research Demand</h3>
                      <p className="text-gray-300 text-base leading-relaxed">
                        Validate that your niche has sufficient audience size and purchasing power to sustain your business. Use keyword research, market analysis tools, and customer surveys to ensure viable demand exists.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Step 2 - Assess Competition */}
            <div className="grid lg:grid-cols-12 gap-8 items-center">
              {/* Number Circle */}
              <div className="lg:col-span-2 flex justify-center lg:justify-end">
                <div className="relative">
                  <div className="w-20 h-20 bg-gradient-to-br from-purple-500 to-purple-600 rounded-full flex items-center justify-center shadow-2xl shadow-purple-500/50">
                    <span className="text-white font-bold text-3xl">2</span>
                  </div>
                  {/* Connecting line */}
                  <div className="hidden lg:block absolute top-20 left-1/2 transform -translate-x-1/2 w-1 h-24 bg-gradient-to-b from-purple-500 to-transparent"></div>
                </div>
              </div>
              
              {/* Content Card */}
              <div className="lg:col-span-10">
                <div className="bg-gradient-to-r from-purple-500/10 to-transparent border-l-4 border-purple-500 rounded-r-2xl p-8 backdrop-blur-sm hover:from-purple-500/20 transition-all duration-300">
                  <div className="flex items-start gap-6">
                    <div className="flex-shrink-0 w-16 h-16 bg-purple-500/20 rounded-xl flex items-center justify-center">
                      <svg className="w-8 h-8 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                      </svg>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-2xl font-bold text-white mb-3">Assess Competition</h3>
                      <p className="text-gray-300 text-base leading-relaxed">
                        Identify gaps where existing solutions fall short and customer needs remain underserved. Analyze competitor weaknesses to find your unique positioning and competitive advantage.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Step 3 - Establish Authority */}
            <div className="grid lg:grid-cols-12 gap-8 items-center">
              {/* Number Circle */}
              <div className="lg:col-span-2 flex justify-center lg:justify-end">
                <div className="relative">
                  <div className="w-20 h-20 bg-gradient-to-br from-cyan-500 to-cyan-600 rounded-full flex items-center justify-center shadow-2xl shadow-cyan-500/50">
                    <span className="text-white font-bold text-3xl">3</span>
                  </div>
                </div>
              </div>
              
              {/* Content Card */}
              <div className="lg:col-span-10">
                <div className="bg-gradient-to-r from-cyan-500/10 to-transparent border-l-4 border-cyan-500 rounded-r-2xl p-8 backdrop-blur-sm hover:from-cyan-500/20 transition-all duration-300">
                  <div className="flex items-start gap-6">
                    <div className="flex-shrink-0 w-16 h-16 bg-cyan-500/20 rounded-xl flex items-center justify-center">
                      <svg className="w-8 h-8 text-cyan-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                      </svg>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-2xl font-bold text-white mb-3">Establish Authority</h3>
                      <p className="text-gray-300 text-base leading-relaxed">
                        Become the recognized expert through consistent, valuable content and genuine community engagement. Build trust and credibility that converts prospects into loyal customers.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          {/* Bottom Highlight Box */}
          <div className="mt-16 relative">
            <div className="absolute inset-0 bg-gradient-to-r from-orange-500/20 via-purple-500/20 to-cyan-500/20 rounded-2xl blur-xl"></div>
            <div className="relative bg-black/60 backdrop-blur-md border border-white/10 rounded-2xl p-5 sm:p-8 lg:p-12">
              <div className="flex items-start gap-6">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-purple-500 rounded-lg flex items-center justify-center">
                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                    </svg>
                  </div>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-white mb-3">Key Success Factor</h4>
                  <p className="text-gray-300 text-base lg:text-lg leading-relaxed">
                    The most successful niche marketing strategies balance passion with profitability. Your chosen niche should align with your expertise while addressing real problems that customers are actively seeking to solve. This intersection creates authentic marketing that resonates deeply and converts effectively.
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* Section 1: Mass Marketing - Broad Reach Strategies */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20">
        <div className="max-w-7xl mx-auto">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-8 sm:mb-12">
            Mass Marketing: Broad Reach Strategies
          </h2>

          <div className="grid lg:grid-cols-2 gap-6 sm:gap-12 items-center">
            
            {/* Left Side - Image */}
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden border-1 border-red-400 shadow-2xl shadow-red-500/50">
                <img 
                  src="/Assests/home_page_74.png" 
                  alt="Mass Marketing Audience" 
                  className="w-full h-[400px] object-cover"
                />
              </div>
              
              {/* Floating glow effects */}
              <div className="absolute top-0 right-0 w-32 h-32 bg-red-500/30 rounded-full blur-3xl animate-pulse" />
              <div className="absolute bottom-0 left-0 w-32 h-32 bg-orange-500/30 rounded-full blur-3xl animate-pulse" style={{animationDelay: '1s'}} />
            </div>

            {/* Right Side - Content */}
            <div className="space-y-6">
              
              {/* Paragraph 1 */}
              <p className="text-gray-300 text-base lg:text-lg leading-relaxed">
                Mass marketing targets the widest possible audience without demographic or psychographic segmentation. This approach assumes your product or service has universal appeal and focuses on maximum exposure through high-volume, broad-reach channels.
              </p>

              {/* Paragraph 2 */}
              <p className="text-gray-300 text-base lg:text-lg leading-relaxed">
                Traditionally employed by major consumer brands with substantial budgets, mass marketing leverages television, radio, billboards, and now digital display advertising to achieve omnipresence. The goal is brand awareness at scale, banking on frequency and reach to drive market penetration.
              </p>

            </div>

          </div>

        </div>
      </section>

      {/* Section 2: When Mass Marketing Makes Sense */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20">
        <div className="max-w-6xl mx-auto">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-8 sm:mb-12">
            When Mass Marketing Makes Sense
          </h2>

          {/* 4 Numbered Points */}
          <div className="space-y-8">
            
            {/* Point 1 */}
            <div className="space-y-3">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-transparent border-2 border-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-orange-500 font-bold text-xl">1</span>
                </div>
                <h3 className="text-2xl font-bold text-white">Universal Products</h3>
              </div>
              <p className="text-gray-300 text-base lg:text-lg leading-relaxed ml-0 sm:ml-16">
                Items with near-universal appeal like beverages, household goods, or basic services that virtually everyone needs regardless of demographics
              </p>
            </div>

            {/* Point 2 */}
            <div className="space-y-3">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-transparent border-2 border-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-orange-500 font-bold text-xl">2</span>
                </div>
                <h3 className="text-2xl font-bold text-white">Large Marketing Budgets</h3>
              </div>
              <p className="text-gray-300 text-base lg:text-lg leading-relaxed ml-0 sm:ml-16">
                Mass campaigns require significant investment to achieve the frequency needed for message penetration across broad channels and diverse media
              </p>
            </div>

            {/* Point 3 */}
            <div className="space-y-3">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-transparent border-2 border-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-orange-500 font-bold text-xl">3</span>
                </div>
                <h3 className="text-2xl font-bold text-white">Market Leadership Goals</h3>
              </div>
              <p className="text-gray-300 text-base lg:text-lg leading-relaxed ml-0 sm:ml-16">
                Brands seeking category dominance use mass marketing to maintain top-of-mind awareness and defend market share against competitors
              </p>
            </div>

            {/* Point 4 */}
            <div className="space-y-3">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-transparent border-2 border-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-orange-500 font-bold text-xl">4</span>
                </div>
                <h3 className="text-2xl font-bold text-white">Economies of Scale</h3>
              </div>
              <p className="text-gray-300 text-base lg:text-lg leading-relaxed ml-0 sm:ml-16">
                Production and distribution capabilities that benefit from volume, where increased demand directly improves unit economics and profitability
              </p>
            </div>

          </div>

        </div>
      </section>

      {/* Section 3: The Evolution of Mass Marketing */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20">
        <div className="max-w-7xl mx-auto">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-8 sm:mb-12">
            The Evolution of Mass Marketing
          </h2>

          <div className="grid lg:grid-cols-2 gap-6 sm:gap-12 items-start">
            
            {/* Left Side - Content with Timeline */}
            <div className="space-y-8">
              
              {/* Introduction Paragraph */}
              <p className="text-gray-300 text-base lg:text-lg leading-relaxed">
                Digital transformation has redefined mass marketing possibilities. What once required million-dollar television budgets can now be achieved through programmatic advertising, viral social content, and strategic influencer partnerships that deliver massive reach at a fraction of traditional costs.
              </p>

              {/* Timeline Items */}
              <div className="space-y-8">
                
                {/* Era 1 */}
                <div className="flex gap-4">
                  <div className="flex flex-col items-center">
                    <div className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-black font-bold">1</span>
                    </div>
                    <div className="w-0.5 h-full bg-orange-500/30 mt-2"></div>
                  </div>
                  <div className="pb-8">
                    <h3 className="text-xl font-bold text-white mb-2">Traditional Era</h3>
                    <p className="text-gray-300 text-base">
                      Television, radio, and print dominated with limited targeting capabilities and high entry barriers
                    </p>
                  </div>
                </div>

                {/* Era 2 */}
                <div className="flex gap-4">
                  <div className="flex flex-col items-center">
                    <div className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-black font-bold">2</span>
                    </div>
                    <div className="w-0.5 h-full bg-orange-500/30 mt-2"></div>
                  </div>
                  <div className="pb-8">
                    <h3 className="text-xl font-bold text-white mb-2">Digital Transition</h3>
                    <p className="text-gray-300 text-base">
                      Internet advertising introduced targeting options while maintaining broad reach potential
                    </p>
                  </div>
                </div>

                {/* Era 3 */}
                <div className="flex gap-4">
                  <div className="flex flex-col items-center">
                    <div className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-black font-bold">3</span>
                    </div>
                    <div className="w-0.5 h-full bg-orange-500/30 mt-2"></div>
                  </div>
                  <div className="pb-8">
                    <h3 className="text-xl font-bold text-white mb-2">Social Media Age</h3>
                    <p className="text-gray-300 text-base">
                      Viral content and influencer networks enable rapid, cost-effective mass distribution
                    </p>
                  </div>
                </div>

                {/* Era 4 */}
                <div className="flex gap-4">
                  <div className="flex flex-col items-center">
                    <div className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-black font-bold">4</span>
                    </div>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">AI-Powered Future</h3>
                    <p className="text-gray-300 text-base">
                      Automated optimization balances broad reach with intelligent audience targeting at scale
                    </p>
                  </div>
                </div>

              </div>

            </div>

            {/* Right Side - Image */}
            <div className="relative lg:sticky lg:top-8">
              <div className="relative rounded-2xl overflow-hidden border-1 border-purple-400 shadow-2xl shadow-purple-500/50">
                <img 
                  src="/Assests/home_page_75.png" 
                  alt="Evolution of Mass Marketing" 
                  className="w-full h-[550px] object-cover"
                />
              </div>
              
              {/* Floating glow effects */}
              <div className="absolute top-0 right-0 w-32 h-32 bg-purple-500/30 rounded-full blur-3xl animate-pulse" />
              <div className="absolute bottom-0 left-0 w-32 h-32 bg-pink-500/30 rounded-full blur-3xl animate-pulse" style={{animationDelay: '1s'}} />
            </div>

          </div>

        </div>
      </section>

      {/* Section 4: Personalized Marketing - The Individual Approach */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 bg-orange-500/60">
        <div className="max-w-7xl mx-auto">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-black mb-6 sm:mb-8">
            Personalized Marketing: The Individual Approach
          </h2>

          {/* Main Description */}
          <p className="text-black text-base lg:text-lg leading-relaxed mb-12 max-w-5xl">
            Personalized marketing leverages data and technology to deliver tailored messages, offers, and experiences to individual customers. By analyzing behavioral patterns, purchase history, browsing data, and demographic information, brands create highly relevant communications that speak directly to each person's interests and needs.
          </p>

          {/* Two Column Section */}
          <div className="grid md:grid-cols-2 gap-5 sm:gap-8">
            
            {/* Column 1 - The Power of Relevance */}
            <div className="space-y-4">
              <h3 className="text-2xl font-bold text-black">The Power of Relevance</h3>
              <p className="text-black text-base lg:text-lg leading-relaxed">
                Generic marketing messages get ignored. Personalized content cuts through the noise by addressing specific pain points, referencing past interactions, and anticipating future needs. This relevance dramatically improves engagement rates, conversion metrics, and customer lifetime value.
              </p>
            </div>

            {/* Column 2 - Technology Enablement */}
            <div className="space-y-4">
              <h3 className="text-2xl font-bold text-black">Technology Enablement</h3>
              <p className="text-black text-base lg:text-lg leading-relaxed">
                Modern marketing platforms harness artificial intelligence, machine learning, and automation to personalize at scale. What was once manually intensive now happens in real-time, adjusting messages based on behavior, context, and predictive analytics.
              </p>
            </div>

          </div>

        </div>
      </section>

      {/* Section 5: Personalization Tactics That Work */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20">
        <div className="max-w-7xl mx-auto">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-8 sm:mb-12 text-center">
            Personalization Tactics That Work
          </h2>

          {/* Dark Container with 3 Cards */}
          <div className="bg-gradient-to-br from-gray-900 to-black rounded-3xl p-8 lg:p-12 border-2 border-orange-400/30">
            
            <div className="grid md:grid-cols-3 gap-8">
              
              {/* Card 1 - Dynamic Email Content */}
              <div className="space-y-4">
                {/* Number Badge */}
                <div className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center">
                  <span className="text-black font-bold text-lg">1</span>
                </div>
                
                {/* Image */}
                <div className="relative rounded-xl overflow-hidden h-48">
                  <img 
                    src="/Assests/home_page_76.png" 
                    alt="Dynamic Email Content" 
                    className="w-full h-full object-cover"
                  />
                </div>
                
                {/* Title */}
                <h3 className="text-xl font-bold text-white">Dynamic Email Content</h3>
                
                {/* Description */}
                <p className="text-gray-300 text-base">
                  Messages adapt based on recipient data, showing relevant products, content, and offers that match individual preferences and behavior
                </p>
              </div>

              {/* Card 2 - Product Recommendations */}
              <div className="space-y-4">
                {/* Number Badge */}
                <div className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center">
                  <span className="text-black font-bold text-lg">2</span>
                </div>
                
                {/* Image */}
                <div className="relative rounded-xl overflow-hidden h-48">
                  <img 
                    src="/Assests/home_page_77.png" 
                    alt="Product Recommendations" 
                    className="w-full h-full object-cover"
                  />
                </div>
                
                {/* Title */}
                <h3 className="text-xl font-bold text-white">Product Recommendations</h3>
                
                {/* Description */}
                <p className="text-gray-300 text-base">
                  AI-powered suggestions based on browsing history, purchase patterns, and similar customer behavior increase cross-sell opportunities
                </p>
              </div>

              {/* Card 3 - Adaptive Web Experiences */}
              <div className="space-y-4">
                {/* Number Badge */}
                <div className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center">
                  <span className="text-black font-bold text-lg">3</span>
                </div>
                
                {/* Image */}
                <div className="relative rounded-xl overflow-hidden h-48">
                  <img 
                    src="/Assests/home_page_78.png" 
                    alt="Adaptive Web Experiences" 
                    className="w-full h-full object-cover"
                  />
                </div>
                
                {/* Title */}
                <h3 className="text-xl font-bold text-white">Adaptive Web Experiences</h3>
                
                {/* Description */}
                <p className="text-gray-300 text-base">
                  Website content dynamically adjusts based on visitor location, referral source, past interactions, and demographic data
                </p>
              </div>

            </div>

          </div>

        </div>
      </section>

      {/* Section 1: Personalization Impact Metrics */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 overflow-hidden">
          <img 
            src="/Assests/home_page_79.png" 
            alt="Personalization Metrics Background" 
            className="w-full h-full object-cover"
          />
        </div>
        
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black/40"></div>

        <div className="max-w-7xl mx-auto relative z-10">
          
          {/* Main Container with Glass Effect */}
          <div className="bg-black/60 backdrop-blur-md border border-white/20 rounded-3xl p-8 lg:p-12">
            
            {/* Main Heading */}
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-8 sm:mb-12">
              Personalization Impact Metrics
            </h2>

            {/* 2x2 Grid */}
            <div className="grid md:grid-cols-2 gap-8 mb-8">
              
              {/* Metric 1 - Consumer Preference */}
              <div className="space-y-3">
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 bg-transparent border-2 border-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-orange-500 font-bold text-lg">1</span>
                  </div>
                  <h3 className="text-xl font-bold text-white">Consumer Preference</h3>
                </div>
                <p className="text-gray-300 text-base">
                  Shoppers more likely to purchase from brands offering personalized experiences
                </p>
              </div>

              {/* Metric 2 - Higher Engagement */}
              <div className="space-y-3">
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 bg-transparent border-2 border-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-orange-500 font-bold text-lg">2</span>
                  </div>
                  <h3 className="text-xl font-bold text-white">Higher Engagement</h3>
                </div>
                <p className="text-gray-300 text-base">
                  Personalized emails generate six times higher transaction rates than generic messages
                </p>
              </div>

              {/* Metric 3 - Revenue Lift */}
              <div className="space-y-3">
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 bg-transparent border-2 border-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-orange-500 font-bold text-lg">3</span>
                  </div>
                  <h3 className="text-xl font-bold text-white">Revenue Lift</h3>
                </div>
                <p className="text-gray-300 text-base">
                  Personalization leaders achieve 40% more revenue from marketing activities than average performers
                </p>
              </div>

              {/* Metric 4 - Customer Expectation */}
              <div className="space-y-3">
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 bg-transparent border-2 border-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-orange-500 font-bold text-lg">4</span>
                  </div>
                  <h3 className="text-xl font-bold text-white">Customer Expectation</h3>
                </div>
                <p className="text-gray-300 text-base">
                  Consumers now expect personalized interactions and feel frustrated by irrelevant content
                </p>
              </div>

            </div>

            {/* Bottom Description */}
            <p className="text-gray-300 text-base lg:text-lg leading-relaxed border-t border-white/10 pt-8">
              The data speaks clearly: personalization isn't optional anymore—it's expected. Brands that master individualized communication build stronger relationships, command premium pricing, and enjoy significantly higher customer retention rates compared to competitors using one-size-fits-all approaches.
            </p>

          </div>

        </div>
      </section>

      {/* Section 2: Comparing Targeting Approaches */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 bg-orange-500/60">
        <div className="max-w-7xl mx-auto">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-8 sm:mb-12">
            Comparing Targeting Approaches
          </h2>

          {/* Table */}
          <div className="bg-gradient-to-br from-orange-400 to-orange-500 rounded-2xl overflow-hidden shadow-2xl">
            
            {/* Table Header */}
            <div className="grid grid-cols-4 bg-black/20 border-b-2 border-black/30">
              <div className="p-4 lg:p-6">
                <h3 className="font-bold text-black text-base lg:text-lg">Strategy</h3>
              </div>
              <div className="p-4 lg:p-6">
                <h3 className="font-bold text-black text-base lg:text-lg">Audience Size</h3>
              </div>
              <div className="p-4 lg:p-6">
                <h3 className="font-bold text-black text-base lg:text-lg">Message Type</h3>
              </div>
              <div className="p-4 lg:p-6">
                <h3 className="font-bold text-black text-base lg:text-lg">Best For</h3>
              </div>
            </div>

            {/* Table Rows */}
            {/* Row 1 - B2B Marketing */}
            <div className="grid grid-cols-4 border-b border-black/20 hover:bg-black/10 transition-colors">
              <div className="p-4 lg:p-6">
                <p className="text-black font-semibold">B2B Marketing</p>
              </div>
              <div className="p-4 lg:p-6">
                <p className="text-black">Specific organizations</p>
              </div>
              <div className="p-4 lg:p-6">
                <p className="text-black">Rational, value-focused</p>
              </div>
              <div className="p-4 lg:p-6">
                <p className="text-black">Enterprise solutions, professional services</p>
              </div>
            </div>

            {/* Row 2 - B2C Marketing */}
            <div className="grid grid-cols-4 border-b border-black/20 hover:bg-black/10 transition-colors">
              <div className="p-4 lg:p-6">
                <p className="text-black font-semibold">B2C Marketing</p>
              </div>
              <div className="p-4 lg:p-6">
                <p className="text-black">Individual consumers</p>
              </div>
              <div className="p-4 lg:p-6">
                <p className="text-black">Emotional, lifestyle-driven</p>
              </div>
              <div className="p-4 lg:p-6">
                <p className="text-black">Consumer products, retail, entertainment</p>
              </div>
            </div>

            {/* Row 3 - C2C Marketing */}
            <div className="grid grid-cols-4 border-b border-black/20 hover:bg-black/10 transition-colors">
              <div className="p-4 lg:p-6">
                <p className="text-black font-semibold">C2C Marketing</p>
              </div>
              <div className="p-4 lg:p-6">
                <p className="text-black">Peer networks</p>
              </div>
              <div className="p-4 lg:p-6">
                <p className="text-black">Trust-based, community-driven</p>
              </div>
              <div className="p-4 lg:p-6">
                <p className="text-black">Marketplaces, sharing economy platforms</p>
              </div>
            </div>

            {/* Row 4 - Niche Marketing */}
            <div className="grid grid-cols-4 border-b border-black/20 hover:bg-black/10 transition-colors">
              <div className="p-4 lg:p-6">
                <p className="text-black font-semibold">Niche Marketing</p>
              </div>
              <div className="p-4 lg:p-6">
                <p className="text-black">Highly specific segment</p>
              </div>
              <div className="p-4 lg:p-6">
                <p className="text-black">Specialized, expert-level</p>
              </div>
              <div className="p-4 lg:p-6">
                <p className="text-black">Specialized products, passionate communities</p>
              </div>
            </div>

            {/* Row 5 - Mass Marketing */}
            <div className="grid grid-cols-4 border-b border-black/20 hover:bg-black/10 transition-colors">
              <div className="p-4 lg:p-6">
                <p className="text-black font-semibold">Mass Marketing</p>
              </div>
              <div className="p-4 lg:p-6">
                <p className="text-black">Broad, undifferentiated</p>
              </div>
              <div className="p-4 lg:p-6">
                <p className="text-black">Universal appeal</p>
              </div>
              <div className="p-4 lg:p-6">
                <p className="text-black">Everyday products, brand awareness campaigns</p>
              </div>
            </div>

            {/* Row 6 - Personalized Marketing */}
            <div className="grid grid-cols-4 hover:bg-black/10 transition-colors">
              <div className="p-4 lg:p-6">
                <p className="text-black font-semibold">Personalized Marketing</p>
              </div>
              <div className="p-4 lg:p-6">
                <p className="text-black">Individual level</p>
              </div>
              <div className="p-4 lg:p-6">
                <p className="text-black">Tailored, data-driven</p>
              </div>
              <div className="p-4 lg:p-6">
                <p className="text-black">E-commerce, subscription services, SaaS</p>
              </div>
            </div>

          </div>

          {/* Bottom Description */}
          <p className="text-gray-200 text-base lg:text-lg leading-relaxed mt-8 max-w-5xl">
            Each targeting strategy serves different business objectives and market conditions. Understanding these distinctions helps marketers allocate resources effectively and set realistic expectations for campaign outcomes.
          </p>

        </div>
      </section>

      {/* Section 3: Choosing Your Targeting Strategy */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20">
        <div className="max-w-7xl mx-auto">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-8 sm:mb-12">
            Choosing Your Targeting Strategy
          </h2>

          {/* 2x2 Grid */}
          <div className="grid md:grid-cols-2 gap-5 sm:gap-8">
            
            {/* Card 1 - Analyze Your Product or Service */}
            <div className="bg-gradient-to-br from-gray-900 to-black border border-orange-500/30 rounded-2xl p-8 space-y-4 hover:border-orange-500/60 transition-all">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-black font-bold text-xl">1</span>
                </div>
                <h3 className="text-2xl font-bold text-white">Analyze Your Product or Service</h3>
              </div>
              <p className="text-gray-300 text-base lg:text-lg leading-relaxed">
                Consider who actually needs what you're offering. Is it universally appealing, or does it solve problems for specific groups? Your product characteristics often dictate viable targeting approaches.
              </p>
            </div>

            {/* Card 2 - Assess Your Resources */}
            <div className="bg-gradient-to-br from-gray-900 to-black border border-orange-500/30 rounded-2xl p-8 space-y-4 hover:border-orange-500/60 transition-all">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-black font-bold text-xl">2</span>
                </div>
                <h3 className="text-2xl font-bold text-white">Assess Your Resources</h3>
              </div>
              <p className="text-gray-300 text-base lg:text-lg leading-relaxed">
                Budget, team capabilities, and technology infrastructure determine which strategies are realistic. Personalized marketing requires data systems, while mass marketing demands significant media spend.
              </p>
            </div>

            {/* Card 3 - Understand Your Competitive Landscape */}
            <div className="bg-gradient-to-br from-gray-900 to-black border border-orange-500/30 rounded-2xl p-8 space-y-4 hover:border-orange-500/60 transition-all">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-black font-bold text-xl">3</span>
                </div>
                <h3 className="text-2xl font-bold text-white">Understand Your Competitive Landscape</h3>
              </div>
              <p className="text-gray-300 text-base lg:text-lg leading-relaxed">
                Identify gaps where competitors aren't serving audiences well. Sometimes the best strategy is the one nobody else is executing effectively in your market.
              </p>
            </div>

            {/* Card 4 - Test and Refine */}
            <div className="bg-gradient-to-br from-gray-900 to-black border border-orange-500/30 rounded-2xl p-8 space-y-4 hover:border-orange-500/60 transition-all">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-black font-bold text-xl">4</span>
                </div>
                <h3 className="text-2xl font-bold text-white">Test and Refine</h3>
              </div>
              <p className="text-gray-300 text-base lg:text-lg leading-relaxed">
                Start with your best hypothesis, but remain flexible. Market feedback and performance data should inform ongoing strategy adjustments and tactical pivots.
              </p>
            </div>

          </div>

        </div>
      </section>

      {/* Section: Hybrid Targeting Approaches */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 bg-orange-500/60">
        <div className="max-w-7xl mx-auto">
          
          {/* Main Heading */}
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-8 text-center">
            Hybrid Targeting Approaches
          </h2>

          {/* Introduction Text */}
          <p className="text-gray-300 text-base lg:text-lg leading-relaxed mb-12 max-w-4xl mx-auto text-center">
            Most successful marketers don't limit themselves to a single targeting strategy. Instead, they combine multiple approaches to maximize reach while maintaining relevance. A consumer brand might use mass marketing for awareness while employing personalized tactics for conversion and retention.
          </p>

          {/* Dark Container */}
          <div className="bg-gradient-to-br from-gray-900 to-black rounded-3xl p-8 lg:p-12 border-2 border-orange-400/30 shadow-2xl">
            
            <div className="grid lg:grid-cols-2 gap-12 items-center mb-12">
              
              {/* Left Side - Description */}
              <div className="space-y-6">
                <p className="text-gray-300 text-base lg:text-lg leading-relaxed">
                  The key is understanding which strategy serves which objective in your customer journey. Mass marketing builds awareness, niche tactics establish authority, and personalization drives conversion. Strategic marketers orchestrate these elements into cohesive campaigns that guide prospects from discovery to purchase.
                </p>
              </div>

              {/* Right Side - Image */}
              <div className="relative">
                <div className="relative rounded-2xl overflow-hidden border-2 border-orange-400 shadow-xl shadow-orange-500/30">
                  <img 
                    src="/Assests/home_page_80.png" 
                    alt="Hybrid Targeting Approach" 
                    className="w-full h-[300px] object-cover"
                  />
                </div>
                
                {/* Floating glow effects */}
                <div className="absolute top-0 right-0 w-24 h-24 bg-orange-500/30 rounded-full blur-2xl animate-pulse" />
                <div className="absolute bottom-0 left-0 w-24 h-24 bg-yellow-500/30 rounded-full blur-2xl animate-pulse" style={{animationDelay: '1s'}} />
              </div>

            </div>

            {/* 4 Strategy Cards Grid */}
            <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
              
              {/* Card 1 - Awareness */}
              <div className="bg-gradient-to-br from-orange-500/20 to-transparent border border-orange-500/30 rounded-2xl p-6 space-y-4 hover:border-orange-500/60 hover:from-orange-500/30 transition-all">
                <div className="w-12 h-12 bg-orange-500 rounded-xl flex items-center justify-center">
                  <svg className="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-white">Awareness</h3>
                <p className="text-gray-300 text-sm">
                  Mass marketing reaches broad audiences
                </p>
              </div>

              {/* Card 2 - Interest */}
              <div className="bg-gradient-to-br from-purple-500/20 to-transparent border border-purple-500/30 rounded-2xl p-6 space-y-4 hover:border-purple-500/60 hover:from-purple-500/30 transition-all">
                <div className="w-12 h-12 bg-purple-500 rounded-xl flex items-center justify-center">
                  <svg className="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-white">Interest</h3>
                <p className="text-gray-300 text-sm">
                  Niche content engages specific segments
                </p>
              </div>

              {/* Card 3 - Conversion */}
              <div className="bg-gradient-to-br from-cyan-500/20 to-transparent border border-cyan-500/30 rounded-2xl p-6 space-y-4 hover:border-cyan-500/60 hover:from-cyan-500/30 transition-all">
                <div className="w-12 h-12 bg-cyan-500 rounded-xl flex items-center justify-center">
                  <svg className="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-white">Conversion</h3>
                <p className="text-gray-300 text-sm">
                  Personalized offers drive purchase decisions
                </p>
              </div>

              {/* Card 4 - Loyalty */}
              <div className="bg-gradient-to-br from-pink-500/20 to-transparent border border-pink-500/30 rounded-2xl p-6 space-y-4 hover:border-pink-500/60 hover:from-pink-500/30 transition-all">
                <div className="w-12 h-12 bg-pink-500 rounded-xl flex items-center justify-center">
                  <svg className="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-white">Loyalty</h3>
                <p className="text-gray-300 text-sm">
                  Relationship marketing retains customers
                </p>
              </div>

            </div>

          </div>

        </div>
      </section>

      {/* Section: Your Path Forward */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20">
        <div className="max-w-7xl mx-auto">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-3xl lg:text-5xl font-bold text-white mb-6 sm:mb-8">
            Your Path Forward
          </h2>

          {/* Introduction Text */}
          <p className="text-gray-300 text-base lg:text-lg leading-relaxed mb-12 max-w-5xl">
            Targeting strategy isn't set in stone—it evolves with your business, market conditions, and customer expectations. The most effective marketers remain curious, test new approaches, and let data guide their decisions rather than assumptions.
          </p>

          {/* 3 Steps Grid */}
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-5 sm:gap-8 mb-8 sm:mb-12">
            
            {/* Step 1 - Start with Clarity */}
            <div className="space-y-4">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 bg-black rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-orange-500 font-bold text-xl">1</span>
                </div>
                <h3 className="text-2xl font-bold text-white">Start with Clarity</h3>
              </div>
              <p className="text-gray-200 text-base lg:text-lg leading-relaxed">
                Define your ideal customer profile and business objectives before selecting targeting tactics. Strategy without clarity leads to wasted resources and mixed messages.
              </p>
            </div>

            {/* Step 2 - Invest in Data */}
            <div className="space-y-4">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 bg-black rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-orange-500 font-bold text-xl">2</span>
                </div>
                <h3 className="text-2xl font-bold text-white">Invest in Data</h3>
              </div>
              <p className="text-gray-200 text-base lg:text-lg leading-relaxed">
                Whether pursuing personalization or testing niche segments, quality data enables better decisions. Build systems that capture, analyze, and activate customer insights.
              </p>
            </div>

            {/* Step 3 - Measure What Matters */}
            <div className="space-y-4">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 bg-black rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-orange-500 font-bold text-xl">3</span>
                </div>
                <h3 className="text-2xl font-bold text-white">Measure What Matters</h3>
              </div>
              <p className="text-gray-200 text-base lg:text-lg leading-relaxed">
                Track metrics aligned with your strategy. B2B focuses on pipeline and deal size, B2C on conversion and lifetime value, personalization on engagement and retention.
              </p>
            </div>

          </div>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-4">
            <button className="px-8 py-4 bg-orange-500 text-white rounded-lg font-semibold text-lg hover:bg-white hover:text-orange-500 hover:shadow-xl transition-all duration-300 transform hover:scale-105">
              Get Started with Your Strategy
            </button>
            <button className="px-8 py-4 bg-orange-500/40 border-2 border-orange-500 text-black rounded-lg font-semibold text-lg hover:bg-black hover:text-orange-500 transition-all duration-300 transform hover:scale-105">
              Download Targeting Framework
            </button>
          </div>

        </div>
      </section>

    </div>
  );
}

export default MarketingTarget;